import React, { useState, useEffect } from 'react';
import { IonIcon, IonButton } from '@ionic/react';
import { downloadOutline, openOutline } from 'ionicons/icons';

const InstallButton = () => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [isInstalled, setIsInstalled] = useState(
        window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true
    );

    useEffect(() => {
        const handleBeforeInstallPrompt = (event) => {
            event.preventDefault();
            setDeferredPrompt(event);
        };

        const handleAppInstalled = () => {
            setIsInstalled(true);
            setDeferredPrompt(null);
        };

        const mediaQuery = window.matchMedia('(display-mode: standalone)');
        const handleDisplayModeChange = () => {
            setIsInstalled(mediaQuery.matches || window.navigator.standalone === true);
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        window.addEventListener('appinstalled', handleAppInstalled);
        mediaQuery.addEventListener('change', handleDisplayModeChange);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
            window.removeEventListener('appinstalled', handleAppInstalled);
            mediaQuery.removeEventListener('change', handleDisplayModeChange);
        };
    }, []);

    const handleInstallClick = async () => {
        if (isInstalled) {
            window.location.assign(window.location.origin);
            return;
        }

        if (deferredPrompt) {
            deferredPrompt.prompt();
            const choiceResult = await deferredPrompt.userChoice;
            if (choiceResult.outcome === 'accepted') {
                setIsInstalled(true);
            }
            setDeferredPrompt(null);
        }
    };

    return (
        <IonButton onClick={handleInstallClick} disabled={!isInstalled && !deferredPrompt}>
            {isInstalled ? 'Open App' : 'Download App'} <IonIcon icon={isInstalled ? openOutline : downloadOutline} />
        </IonButton>
    );
};

export default InstallButton;
